import createReducer, { mergeReducers } from "../../../lib/createReducer";
import { SHARE_FILTER_GRAPH_REQUEST, SHARE_FILTER_GRAPH_SUCCESS, SHARE_FILTER_GRAPH_ERROR } from "./action";

const init = {
  isFetching: false,
  fetchSuccess: false,
  hasError: false,
  payload: null,
  error: null,
};

const requestReducer = createReducer(
  SHARE_FILTER_GRAPH_REQUEST,
  () => ({
    ...init,
    isFetching: true,
  }),
  true
);

const successReducer = createReducer(SHARE_FILTER_GRAPH_SUCCESS, ({ response }) => ({
  isFetching: false,
  fetchSuccess: true,
  payload: response,
}));

const errorReducer = createReducer(SHARE_FILTER_GRAPH_ERROR, ({ error }) => ({
  isFetching: false,
  hasError: true,
  error,
}));

export default mergeReducers([requestReducer, successReducer, errorReducer], init);
